<script>
/**
 * String cell.
 *
 * Renders a plain string.
 * Renders a <input type="text" /> when in edit mode.
 *
 * See ColumnMixin for more docs.
 */

import ColumnMixin from './ColumnMixin';

export default {
    mixins: [ColumnMixin],
    name: 'StringCell'
};
</script>

<template>
    <div v-if="editing">
        <div>
            <input
                v-on:keyup="onKeyUp"
                type="text"
                class="form-control"
                v-model="val"
                v-bind:minlength="min"
                v-bind:maxlength="max"
                v-bind:placeholder="column.label"
                ref="input"
                />
        </div>

        <component
            v-bind:is="editableToolbar"
            v-bind:config="editableToolbarConfig"
            v-on:accepted="submit"
            v-on:rejected="reset"
            >
        </component>

    </div>
    <span v-else>{{ formatted }}</span>
</template>

<style scoped>
input {
    font-size: 13px !important;
    height: 23px;
}
</style>
